// Module
var code = `<base-button btn-context="{{btnContext}}" btn-size="{{btnSize}}" btn-type="{{btnType}}"> <i class="fa fa-eye" aria-hidden="true"></i> <span ng-if="!btnIconOnly">{{ 'Generic.Preview' | translate }}</span> </base-button> `;
// Exports
module.exports = code;